import { useSearchParams } from "react-router-dom-v5-compat";

import useFetchParentData from "features/sign-up/hooks/useFetchParentData";

export default function useParentDataPrefill() {
  const [searchParams] = useSearchParams();
  const connectionKey = searchParams.get("connectionKey");
  const { data: parentData, isLoading: isParentDataLoading } =
    useFetchParentData(connectionKey);

  return {
    hasConnectionKey: !!connectionKey,
    parentData,
    isParentDataLoading
  };
}
